import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  checkInputErrorMaxLength,
  checkInputErrorOnlyNumbers,
  checkInputErrorRegEx,
  checkInputErrorRequired,
  useInput
} from '@chilecompra/react-kit'
import { Input, Typography } from '@chilecompra/react-kit/components'
import { useImperativeFormRef } from './QuoteStepOne.hooks'
import { EMAIL_CHECK } from '../../modules/utils/regexes'
import { Grid, Prefix } from './QuoteStepOne.styles'

/**
 * The ContactInformation's component.
 */
const ContactInformation = props => {
  const { contact, formRef, isDownToTiny } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)
  const {
    error: contactNameError,
    value: contactNameValue,
    onChange: handleContactNameChange
  } = useInput({
    errorCallbacks: [checkInputErrorRequired(), checkInputErrorMaxLength(200)],
    overwriteCallback: () => contact?.name
  })
  const {
    error: contactPhoneError,
    value: contactPhoneValue,
    onChange: handleContactPhoneChange
  } = useInput({
    errorCallbacks: [checkInputErrorOnlyNumbers(), checkInputErrorMaxLength(9), checkInputErrorRequired()],
    overwriteCallback: () => contact?.phone?.replace('+56', '').replaceAll(' ', '').trim()
  })
  const {
    error: contactEmailError,
    value: contactEmailValue,
    onChange: contactEmailChange,
    setValue: setContactEmailValue
  } = useInput({
    errorCallbacks: [
      checkInputErrorRequired(),
      checkInputErrorMaxLength(200),
      checkInputErrorRegEx(EMAIL_CHECK, 'Formato de email incorrecto.')
    ],
    overwriteCallback: () => contact?.email
  })

  useImperativeFormRef(
    formRef,
    () => ({
      contactEmailError,
      contactEmailValue,
      contactNameError,
      contactNameValue,
      contactPhoneError,
      contactPhoneValue
    }),
    [contactEmailError, contactEmailValue, contactNameError, contactNameValue, contactPhoneError, contactPhoneValue]
  )

  const handleLoweCase = () => setContactEmailValue(contactEmailValue.toLowerCase())

  return (
    <Grid container margin="24px 0 24px">
      <Grid container item sm direction="column" padding="2px 32px 0 0" xs={12}>
        <Typography fontWeight="bold" variant="body2">
          Datos de contacto
        </Typography>
        <Typography fontWeight="regular" color="black1" variant="body2">
          Esta información no será visible para los proveedores, ni se mostrará en tu Ficha de Compra Ágil.
        </Typography>
      </Grid>
      <Grid item sm={8} xs={12}>
        <Grid container item sm padding={isDownToTiny ? '16px 0 0' : '0'}>
          <Input
            disabled={authInfo.hasObserverRole}
            error={contactNameError}
            label="Nombre y apellido"
            value={contactNameValue}
            onChange={handleContactNameChange}
          />
        </Grid>
        <Grid container item sm>
          <Grid item padding={isDownToTiny ? '16px 0 0' : '0 16px 0 0'} sm={6} xs={12}>
            <Input
              disabled={authInfo.hasObserverRole}
              error={contactPhoneError}
              info="Ejemplo: +56 912345678"
              label="Teléfono de contacto"
              prefix={<Prefix>+56</Prefix>}
              type="number"
              maxCount={9}
              maxLength={9}
              value={contactPhoneValue}
              onChange={handleContactPhoneChange}
            />
          </Grid>
          <Grid item padding={isDownToTiny ? '16px 0 0' : '0 0 0 16px'} sm={6} xs={12}>
            <Input
              disabled={authInfo.hasObserverRole}
              error={contactEmailError}
              label="Correo electrónico"
              type="email"
              value={contactEmailValue}
              onBlur={handleLoweCase}
              onChange={contactEmailChange}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

ContactInformation.defaultProps = {
  contact: {},
  formRef: {
    current: {}
  },
  isDownToTiny: false
}

ContactInformation.propTypes = {
  contact: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string
  }),
  formRef: PropTypes.shape({
    current: PropTypes.shape(Object)
  }),
  isDownToTiny: PropTypes.bool
}

export default ContactInformation
